import styled from 'styled-components'
import { DefaultFontStyle } from '../../styles/global-styles'
import { HoverText } from '../seat-picker/seat-picker-styles'

export const FaqContainer = styled.div`
  ${DefaultFontStyle};
  max-width: 1100px;
  margin: 16px auto;
  padding: 50px;

  @media (max-width: ${props => props.theme.breakpoints.sm}px) {
    margin-top: -50px;
  }
`

export const Faq = styled.div`
  margin-bottom: 50px;
`

export const Title = styled.h3`
  font-weight: 600;
  font-size: 30px;
  line-height: 44px;
  margin-block-start: 59px;
  margin-block-end: 0px;
`

export const Question = styled.h4`
  font-weight: 600;
  font-size: 20px;
  line-height: 28px;
  margin-block-start: 35px;
  margin-block-end: 0px;
  justify-content: space-between;
  display: flex;

  &:hover {
    cursor: pointer;
  }
`

export const Answer = styled.p`
  font-weight: 400;
  font-family: 'Poppins';
  font-size: 16px;
  line-height: 30px;
  margin-block-start: 12px;
  margin-block-end: 42px;
  white-space: pre-wrap;
`

export const HR = styled.hr`
  width: 100%;
  border: 1px solid #d9d9d9;
  margin-top: 40px;
`

export const FaqButtonContent = styled.div`
  display: flex;
  gap: 30px;
  align-items: center;
  flex-direction: column;
  flex: 1;
  margin-top: 55px;
  font-family: 'Poppins';
  font-size: 16px;
  line-height: 20px;
  text-align: center;
  font-weight: 600;

  @media (max-width: ${props => props.theme.breakpoints.sm}px) {
    margin-top: 24px;
    gap: 15px;
    font-size: 12px;
    line-height: 18px;
  }

  @media (min-width: 667px) {
    width: 111px;
    height: 135px;
    margin-top: 10px;
    display: flex;
    align-items: center;
    flex-direction: column;
    font-family: 'Poppins';
    line-height: 18px;
    text-align: center;
    font-weight: 600;
    font-size: 12px;
  }
`

export const ButtonContent = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: center;
  flex: 1;

  @media (max-width: ${props => props.theme.breakpoints.sm}px) {
    display: flex;
    justify-content: center;
  }

  @media (min-width: 667px) {
    width: 150px;
    height: 126px;
    gap: 10px;
  }
`

export const FaqStyledButton = styled.button`
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 200px;
  height: 210px;
  border: none;
  border-radius: 10px;
  box-shadow: 0px 5px 16px rgba(31, 32, 33, 0.08);
  cursor: ${({ disabled }) => !disabled && 'pointer'};
  color: black;
  background: ${props => props.theme.colours.white};
  background-color: ${props => (props.disabled ? '#ebebeb' : props.theme.colours.white)};
  &:hover {
    ${HoverText} {
      visibility: visible;
      bottom: 25px;
    }
  }

  @media (max-width: ${props => props.theme.breakpoints.sm}px) {
    display: flex;
    align-items: center;
    flex-direction: column;
    width: 150px;
    height: 126px;
    border: none;
    border-radius: 10px;
    box-shadow: 0px 5px 16px rgba(31, 32, 33, 0.08);
    color: black;
  }

  @media (min-width: 667px) {
    width: 150px;
    height: 126px;
  }
`
export const FaqTypeIcon = styled.img`
  width: 45px;
  height: 46px;
  align-self: center;

  @media (max-width: ${props => props.theme.breakpoints.sm}px) {
    width: 77px;
    height: 35px;
    align-self: center;
  }
`

export const FaqTypeButtonFlexBox = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 14px;
  margin-top: 70px;

  @media (max-width: ${props => props.theme.breakpoints.sm}px) {
    margin-top: 30px;
    font-size: 16px;
    align-items: center;
    display: grid;
    padding-right: 35px;
    padding-left: 35px;
    grid-template-columns: repeat(2, 50%);
    grid-column-gap: 17px;
    grid-auto-rows: minmax(10px, auto);
    & :nth-child(7) {
      display: flex;
      align-items: center;
      margin-left: 86px;
    }
  }
`
